import { satisfactionQuestionsService } from '@/services/satisfactionQuestions.service.js';

const state = {
  questionsOutput: null,
  formOutput: null,
  formsOutput: null
};

const mutations = {
  setQuestionsOutput(state, payload) {
    state.questionsOutput = payload;
  },
  setFormOutput(state, payload) {
    state.formOutput = payload;
  },
  setFormsOutput(state, payload) {
    state.formsOutput = payload;
  }
};

const actions = {
  async getQuestions({ commit }, queryParams) {
    try {
      const response = await satisfactionQuestionsService.getQuestions(queryParams);
      commit('setQuestionsOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching satisfaction questions:', error);
      throw error;
    }
  },
  
  async getFormById({ commit }, id) {
    try {
      const response = await satisfactionQuestionsService.getFormById(id);
      commit('setFormOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching satisfaction form by id:', error);
      throw error;
    }
  },
  
  async getForms({ commit }, queryParams) {
    try {
      const response = await satisfactionQuestionsService.getForms(queryParams);
      commit('setFormsOutput', response);
      return response;
    } catch (error) {
      console.error('Error fetching satisfaction forms:', error);
      throw error;
    }
  }
};

const getters = {
  questions: state => state.questionsOutput?.data || [],
  form: state => state.formOutput?.data || null,
  forms: state => state.formsOutput?.data || []
};

export const satisfactionQuestions = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};

